import { render } from "./ExampleGallery.vue?vue&type=template&id=66fbd9f0&scoped=true"
import script from "./ExampleGallery.vue?vue&type=script&lang=js"
export * from "./ExampleGallery.vue?vue&type=script&lang=js"

import "./ExampleGallery.vue?vue&type=style&index=0&id=66fbd9f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fbd9f0"]])

export default __exports__